<aside class="sidebar-inner">
  <!-- <ul> 
      <li><a routerLink="/dashboard/all-application">All Application</a></li>
     <li><a routerLink="/dashboard/agent">Agent</a></li>
    </ul> -->

  <!-- <div class="hamburger-nav" (click)="hamburgerToggleDiv()"></div> -->
  <div class="logo-wrapper">
    <a href="javascript:void(0)" class="logo" (click)="isOnMailPage ? redirectToDashboard() : null">
      <img class="logo-default" [src]="brandLogo" alt="Logo" title="Logo" />
      <img class="logo-icon" [src]="brandLogoIcon" alt="Logo" title="Logo" />
    </a>
  </div>

  <mat-accordion class="mat-accordion" multi="false">
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.dashboard] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/dashboard-icon-gray.svg" alt="Dashboard" />
          <img class="icon active" src="./assets/images/dashboard-icon-orange.svg" alt="Dashboard" />
          <span class="label" (click)="goToDashboard()">Dashboard</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.dashboardrm] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/dashboard-icon-gray.svg" alt="RM Dashboard" />
          <img class="icon active" src="./assets/images/dashboard-icon-orange.svg" alt="RM Dashboard" />
          <span class="label" (click)="goToRmDashboard()">RM Dashboard</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.dashboardmm] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/dashboard-icon-gray.svg" alt="RM Dashboard" />
          <img class="icon active" src="./assets/images/dashboard-icon-orange.svg" alt="RM Dashboard" />
          <span class="label" (click)="goToMmDashboard()">MM Dashboard</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.application_dashboard] | permissions | async
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/dashboard-icon-gray.svg" alt="RM Dashboard" />
          <img class="icon active" src="./assets/images/dashboard-icon-orange.svg" alt="RM Dashboard" />
          <span class="label" (click)="goToApplicationDashboard()">Application Dashboard</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.africa_dashboard] | permissions | async
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/dashboard-icon-gray.svg" alt="RM Dashboard" />
          <img class="icon active" src="./assets/images/dashboard-icon-orange.svg" alt="RM Dashboard" />
          <span class="label" matTooltip="Dashboard Africa" (click)="goToAfricaDashboard()">Dashboard(A)</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.application_status_tat] | permissions | async
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/dashboard-icon-gray.svg" alt="RM Dashboard" />
          <img class="icon active" src="./assets/images/dashboard-icon-orange.svg" alt="RM Dashboard" />
          <span class="label" matTooltip="Application Status TAT" (click)="goToApplicationStatusTat()">Application Status TAT</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.application_status_tat] | permissions | async
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/dashboard-icon-gray.svg" alt="RM Dashboard" />
          <img class="icon active" src="./assets/images/dashboard-icon-orange.svg" alt="RM Dashboard" />
          <span class="label" matTooltip="Application Secondary Status TAT" (click)="goToApplicationSecondaryStatusTat()">Secondary Status TAT</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>  

    <mat-expansion-panel *ngIf="
        ([permissions_entity.modules.agents] | permissions | async) ||
        ([permissions_entity.modules.non_approved_agent]
          | permissions
          | async) ||
        ([permissions_entity.modules.non_approved_agent] | permissions | async)
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/agent-icon-gray.svg" alt="Agents" />
          <img class="icon active" src="./assets/images/agent-icon-orange.svg" alt="Agents" />
          <span class="label">Agents</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.agents] | permissions | async">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          [routerLink]="['/dashboard/agent']" (click)="goToAgent($event)">
          All Agent
        </a>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.non_approved_agent] | permissions | async
        ">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard/agent/nonApproveAgent']">
          Non Approved Agent
        </a>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.search_agent] | permissions | async">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard/agent/searchAgent']">
          Search Agent
        </a>
      </div>

      <div class="expansion-content" *ngIf="[permissions_entity.modules.agent_rating_logs] | permissions | async">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard/uk-mock-interview/agent-comments']">
          Agent Rating Logs
        </a>
      </div>

      <div class="expansion-content" *ngIf="[permissions_entity.modules.counsellor] | permissions | async">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard/agent/counsellor']">
          Counsellor
        </a>
      </div>
    </mat-expansion-panel>


    <mat-expansion-panel *ngIf="[permissions_entity.modules.applications] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/application-icon-gray.svg" alt="Applications" />
          <img class="icon active" src="./assets/images/application-icon-orange.svg" alt="Applications" />
          <span class="label">Applications</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          [routerLink]="['/dashboard/all-application']" (click)="goToApplications($event)">
          All Applications
        </a>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.offered_issued] | permissions | async
        ">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard/all-application/offered-issued']">
          Offered Issued
        </a>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.application_processed] | permissions | async">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard/all-application/application-processed']">
          Application Processed
        </a>
      </div>
    </mat-expansion-panel>


    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.uk_mock_interview] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            [routerLink]="['/dashboard/uk-mock-interview']" (click)="goToUkMockInterview($event)">
            <img class="icon normal" src="./assets/images/application-icon-gray.svg" alt="UK Mock Interview" />
            <img class="icon active" src="./assets/images/application-icon-orange.svg" alt="UK Mock Interview" />
            <span class="label">UK Mock Interview</span>
          </a>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <!-- <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.agent_rating_logs] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            [routerLink]="['/dashboard/uk-mock-interview/agent-comments']">
            <img class="icon normal" src="./assets/images/application-icon-gray.svg" alt="Agent Review Logs" />
            <img class="icon active" src="./assets/images/application-icon-orange.svg" alt="Agent Review Logs" />
            <span class="label">Agent Review Logs</span>
          </a>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel> -->



    <!-- <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.applications] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <a class="nav-link" [routerLink]="['/dashboard/all-application']" (click)="goToApplications($event)">
            <img class="icon normal" src="./assets/images/application-icon-gray.svg" alt="Application" />
            <img class="icon active" src="./assets/images/application-icon-orange.svg" alt="Application" />
            <span class="label">All Applications</span>
          </a>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="expansion-content">
                <button mat-button (click)="goToApplications()">Application</button>
            </div>
    </mat-expansion-panel> -->

    <mat-expansion-panel *ngIf="[permissions_entity.modules.all_leads, permissions_entity.modules.lead_campaign] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/application-icon-gray.svg" alt="Leads" />
          <img class="icon active" src="./assets/images/application-icon-orange.svg" alt="Leads" />
          <span class="label">Leads</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.all_leads] | permissions | async">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          [routerLink]="['/dashboard/all-leads']">
          All Leads
        </a>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.lead_campaign] | permissions | async">
        <a mat-button class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard/all-leads/lead-campaigns']">
          Lead Campaign
        </a>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.lead_tracking] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <a class="nav-link" (click)="goToLeadTracking($event)">
            <img class="icon normal" src="./assets/images/application-icon-gray.svg" alt="Lead Tracking" />
            <img class="icon active" src="./assets/images/application-icon-orange.svg" alt="Lead Tracking" />
            <span class="label">Lead Tracking</span>
          </a>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <!-- <mat-expansion-panel hideToggle> -->
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.partner_survey] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <a class="nav-link" (click)="goToPartnerSurvey($event)">
            <img class="icon normal" src="./assets/images/application-icon-gray.svg" alt="Application" />
            <img class="icon active" src="./assets/images/application-icon-orange.svg" alt="Application" />
            <span class="label">Partner Survey</span>
          </a>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.archived] | permissions | async">
      <mat-expansion-panel-header (click)="goToArchivedApplications()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/archive-icon-gray.svg" alt="Application (Archived)" />
          <img class="icon active" src="./assets/images/archive-icon-orange.svg" alt="Application (Archived)" />
          <span class="label">Application (Archived)</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="
        ([permissions_entity.modules.data_entry_application]
          | permissions
          | async) ||
        ([permissions_entity.modules.data_entry_assign_application]
          | permissions
          | async)
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/course-icon-gray.svg" alt="Data entry Application" />
          <img class="icon active" src="./assets/images/course-icon-orange.svg" alt="Data entry Application" />
          <span class="label">Data Entry Application</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button *ngIf="
            [permissions_entity.modules.data_entry_application]
              | permissions
              | async
          " (click)="dataApplicaton()">
          All Application
        </button>
        <button mat-button *ngIf="
            [permissions_entity.modules.data_entry_assign_application]
              | permissions
              | async
          " (click)="dataApplicatonMy()">
          My Application
        </button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="[permissions_entity.modules.art_received] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/course-icon-gray.svg" alt="ART Application" />
          <img class="icon active" src="./assets/images/course-icon-orange.svg" alt="ART Application" />
          <span class="label">ART Applications</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button (click)="artApplicaton()">All Application</button>
        <button mat-button (click)="artApplicatonMy()">My Application</button>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="[permissions_entity.modules.cat] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/course-icon-gray.svg" alt="Case Owner" />
          <img class="icon active" src="./assets/images/course-icon-orange.svg" alt="Case Owner" />
          <span class="label">Case Owner</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content" (click)="goToAllCaseList()"
        *ngIf="[permissions_entity.modules.cat_all_case] | permissions | async">
        <button mat-button>All Case</button>
      </div>
      <div class="expansion-content" (click)="goToMyCaseList()"
        *ngIf="[permissions_entity.modules.cat_my_case] | permissions | async">
        <button mat-button>My Case</button>
      </div>
      <div class="expansion-content" (click)="goToChangeCaseOwnerList()" *ngIf="
          [permissions_entity.modules.cat_change_case_owner]
            | permissions
            | async
        ">
        <button mat-button>Change Case Owner</button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="
        ([permissions_entity.modules.cpt_document_verification]
          | permissions
          | async) ||
        ([permissions_entity.modules.cpt_assign_application]
          | permissions
          | async) ||
        ([permissions_entity.modules.cpt_processed_application]
          | permissions
          | async)
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/course-icon-gray.svg" alt="CPT" />
          <img class="icon active" src="./assets/images/course-icon-orange.svg" alt="CPT" />
          <span class="label">CPT</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button (click)="goToDocumentVerification()" *ngIf="
            [permissions_entity.modules.cpt_document_verification]
              | permissions
              | async
          ">
          Document Verification
        </button>
        <button mat-button (click)="goToAssignApplications()" *ngIf="
            [permissions_entity.modules.cpt_assign_application]
              | permissions
              | async
          ">
          Assign Application
        </button>
        <button mat-button (click)="goToProcessedApplications()" *ngIf="
            [permissions_entity.modules.cpt_processed_application]
              | permissions
              | async
          ">
          Processed Application
        </button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="
        ([permissions_entity.modules.support_chat] | permissions | async) ||
        ([permissions_entity.modules.whatsapp_group] | permissions | async) ||
        ([permissions_entity.modules.whatsapp_group_analytics] | permissions | async) ||
        ([permissions_entity.modules.whatsapp_group_escalations] | permissions | async) ||
        ([permissions_entity.modules.chat_analytics] | permissions | async) ||
        ([permissions_entity.modules.conversations_log] | permissions | async) ||
        ([permissions_entity.modules.agent_communications] | permissions | async)
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/application-icon-gray.svg" alt="Application" />
          <img class="icon active" src="./assets/images/application-icon-orange.svg" alt="Application" />
          <span class="label">Chat</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <!-- <button mat-button (click)="coventryChat()">Coventry Support Chat</button> -->
        <button mat-button *ngIf="
            [permissions_entity.modules.agent_communications] | permissions | async
          " (click)="dynamicRoute('/dashboard/chat-master/agent-communications')">
          Agent Communications
        </button>
        <!-- <button mat-button (click)="gotoWhatsappAnalytics()">Whatsapp Analytics</button> -->
        <!-- <button mat-button (click)="gotoCampaign()">Campaign</button> -->
        <button mat-button *ngIf="
            [permissions_entity.modules.support_chat] | permissions | async
          " (click)="dynamicRoute('/dashboard/chat-master/all-chats-whatsapp')">
          Whatsapp Chat
        </button>
        <button mat-button *ngIf="
            [permissions_entity.modules.chat_analytics] | permissions | async
          " (click)="goInboxAnalytics()">
          Chat Analytics
        </button>
        <button mat-button *ngIf="
            [permissions_entity.modules.conversations_log] | permissions | async
          " (click)="goConversationLogs()">
          Conversations Log
        </button>
        <button mat-button *ngIf="
            [permissions_entity.modules.conversations_delay_log]
              | permissions
              | async
          " (click)="goConversationDelayLogs()">
          Conversations Delay Log
        </button>
        <button mat-button *ngIf="
            [permissions_entity.modules.whatsApp_log] | permissions | async
          " (click)="whatsappReport()">
          WhatsApp Call Log
        </button>
        <button mat-button *ngIf="
            [permissions_entity.modules.chat_analytics_report]
              | permissions
              | async
          " (click)="chatAnalyticsReport()">
          Chat Analytics (Power BI)
        </button>
        <button mat-button *ngIf="
            [permissions_entity.modules.group_chat] | permissions | async
          " (click)="goToWhatsappGroup()">
          Group Chat
        </button>
        <button mat-button *ngIf="
            [permissions_entity.modules.whatsapp_group_analytics]
              | permissions
              | async
          " (click)="goToWhatsappGroupAnalytics()">
          Group Analytics
        </button>
        <button mat-button *ngIf="
            [permissions_entity.modules.whatsapp_group_escalations]
              | permissions
              | async
          " (click)="goToWhatsappGroupEscalations()">
          Escalations
        </button>
      </div>
    </mat-expansion-panel>

    <!-- bulk-mailer menu start -->
    <mat-expansion-panel *ngIf="
        [
          permissions_entity.modules.campaigns,
          permissions_entity.modules.audience,
          permissions_entity.modules.mail_template,
          permissions_entity.modules.media,
        ]
          | permissions
          | async
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/mailbox-icon-gray.svg" alt="Inbox" />
          <img class="icon active" src="./assets/images/mailbox-icon-orange.svg" alt="Inbox" />
          <span class="label">Bulk Mailer</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content mail-btns-group">
        <button mat-button (click)="goToBulkMailer('campaigns')"
          *ngIf="[permissions_entity.modules.campaigns] | permissions | async">
          Campaigns
        </button>

        <button mat-button (click)="goToBulkMailer('internal-campaigns')" *ngIf="
            [permissions_entity.modules.internal_campaigns]
              | permissions
              | async
          ">
          Internal Campaigns
        </button>

        <!-- Nested Audience Expansion Panel -->
        <!-- <mat-expansion-panel expanded="true" class="nested-panel audience-panel" *ngIf="([ permissions_entity.modules.audience ] | permissions | async)">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <span class="label">Audience</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="expansion-content nested-content">
                        <button mat-button (click)="goToAudienceSegments()">Segments</button>
                        <button mat-button (click)="goToAudienceContacts()">Contacts</button>
                        <button mat-button (click)="goToAudienceTags()">Tags</button>
                    </div>
                </mat-expansion-panel> -->
        <button mat-button (click)="goToAudienceSegments()"
          *ngIf="[permissions_entity.modules.audience] | permissions | async">
          Segments
        </button>
        <button mat-button (click)="goToAudienceContacts()"
          *ngIf="[permissions_entity.modules.audience] | permissions | async">
          Contacts
        </button>
        <button mat-button (click)="goToAudienceTags()"
          *ngIf="[permissions_entity.modules.audience] | permissions | async">
          Tags
        </button>
        <button mat-button (click)="goToBulkMailer('mail-templates')" *ngIf="
            [permissions_entity.modules.mail_template] | permissions | async
          ">
          Mail Template
        </button>
        <button mat-button (click)="goToBulkMailer('mail-media')"
          *ngIf="[permissions_entity.modules.media] | permissions | async">
          Media
        </button>
      </div>
    </mat-expansion-panel>
    <!-- bulk-mailer menu end -->
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.lead_scheduler] | permissions | async">
      <mat-expansion-panel-header (click)="dynamicRoute('/dashboard/lead-scheduler')">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/report-icon-gray.svg" alt="Lead Scheduler" />
          <img class="icon active" src="./assets/images/report-icon-orange.svg" alt="Lead Scheduler" />
          <span class="label">Lead Scheduler</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.lead_form] | permissions | async">
      <mat-expansion-panel-header (click)="goToLeadForm()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/dynamic-form.svg" alt="Create Dynamic Automation Form" />
          <img class="icon active" src="./assets/images/dynamic-form-orange.svg" alt="Create Dynamic Automation Form" />
          <span class="label">Lead Form</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.mail_box] | permissions | async">
      <mat-expansion-panel-header (click)="goToMailbox()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/mailbox-icon-gray.svg" alt="Inbox" />
          <img class="icon active" src="./assets/images/mailbox-icon-orange.svg" alt="Inbox" />
          <span class="label">Mailbox</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <!-- <h2
            *ngIf="([permissions_entity.modules.my_drive] | permissions | async) || ([permissions_entity.modules.my_drive] | permissions | async) || ([permissions_entity.modules.my_drive] | permissions | async) || ([permissions_entity.modules.my_drive] | permissions | async)">
            Managers</h2> -->
    <!-- <mat-expansion-panel
            *ngIf="([permissions_entity.modules.my_drive] | permissions | async) || ([permissions_entity.modules.my_drive] | permissions | async) || ([permissions_entity.modules.my_drive] | permissions | async) || ([permissions_entity.modules.my_drive] | permissions | async)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <img class="icon normal" src="./assets/images/file-mager-gray.svg" alt="Student Interview" />
                    <img class="icon active" src="./assets/images/file-mager-orange.svg" alt="Student Interview" />
                    <span class="label">File Manager</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="expansion-content" *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
                <button mat-button (click)="goToMyDrive()">My Drive</button>
            </div>
            <div class="expansion-content" *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
                <button mat-button (click)="goToImportant()">Important</button>
            </div>
            <div class="expansion-content" *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
                <button mat-button (click)="goToSharedWithMe()">Share with Me</button>
            </div>
            <div class="expansion-content" *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
                <button mat-button (click)="goToSharedByMe()">Share by Me</button>
            </div>
            <div class="expansion-content">
                <button mat-button (click)="goToSharedDrive()">Shared Drive</button>
            </div>
        </mat-expansion-panel> -->

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
      <mat-expansion-panel-header (click)="goToFileManagerV3()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/file-mager-gray.svg" alt="File Manager" />
          <img class="icon active" src="./assets/images/file-mager-orange.svg" alt="File Manager" />
          <span class="label">File Manager</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <!-- <mat-expansion-panel *ngIf="([permissions_entity.modules.my_drive] | permissions | async)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <a class="nav-link" (click)="goToFileManagerV3()">
                        <img class="icon normal" src="./assets/images/file-mager-gray.svg" alt="Student Interview" />
                        <img class="icon active" src="./assets/images/file-mager-orange.svg" alt="Student Interview" />
                        <span class="label">File Manager</span>
                    </a>
                </mat-panel-title>
            </mat-expansion-panel-header>
            @if (false) {
            <div class="expansion-content" *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
                <button mat-button (click)="goToSwitchDrive2()">Switch Drive</button>
            </div>
            }
            <div class="expansion-content" *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
                <button mat-button (click)="goToMyDrive2()">My Drive</button>
            </div>
            <div class="expansion-content" *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
                <button mat-button (click)="goToShares2()">Shares Drive V2</button>
            </div>
            <div class="expansion-content" *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
                <button mat-button (click)="goSharedWithMe2()">Shared With Me</button>
            </div>
            <div class="expansion-content" *ngIf="[permissions_entity.modules.my_drive] | permissions | async">
                <button mat-button (click)="goSharedWithOthers2()">Shared By Me</button>
            </div>
        </mat-expansion-panel> -->

    <h2 *ngIf="
        ([permissions_entity.modules.search_courses] | permissions | async) ||
        ([permissions_entity.modules.search_universities]
          | permissions
          | async) ||
        ([permissions_entity.modules.training_hub_business]
          | permissions
          | async) ||
        ([permissions_entity.modules.university_country_training]
          | permissions
          | async)
      ">
      B2C Module
    </h2>
    <!-- Search Program — replaces the two entries below, which are now one
         page with a Courses / Universities tab strip (see ProgramsComponent).
         Visible to anyone who had EITHER of the old permissions, since the
         single entry now covers both. -->
    <mat-expansion-panel hideToggle *ngIf="
        [
          permissions_entity.modules.search_courses,
          permissions_entity.modules.search_universities
        ] | permissions | async
      ">
      <mat-expansion-panel-header (click)="searchProgram()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/book-shelf-fill.svg" alt="Search Program" />
          <img class="icon active" src="./assets/images/book-shelf-fill.svg" alt="Search Program" />
          <span class="label">Search Program</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <!-- UNWIRED 2026-09-21 — superseded by "Search Program" above. Left in
         place (markup, component, routes and all) rather than deleted so the
         old B2C pages stay buildable and can be put back by un-commenting.
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.search_courses] | permissions | async">
      <mat-expansion-panel-header (click)="courseSearch()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/book-shelf-fill.svg" alt="Course Search" />
          <img class="icon active" src="./assets/images/book-shelf-fill.svg" alt="Course Search" />
          <span class="label">Course Search</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.search_universities] | permissions | async
      ">
      <mat-expansion-panel-header (click)="universitySearch()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/building-fill.svg" alt="University Search" />
          <img class="icon active" src="./assets/images/building-fill.svg" alt="University Search" />
          <span class="label">University Search</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    -->
    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.university_country_training]
          | permissions
          | async
      ">
      <mat-expansion-panel-header (click)="universityCountryTraing()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/flag-gray.svg" alt="Country Training" />
          <img class="icon active" src="./assets/images/flag-gray.svg" alt="Country Training" />
          <span class="label">Country Training</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.training_hub_business] | permissions | async
      ">
      <mat-expansion-panel-header (click)="trainingHub()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/presentation-fill.svg" alt="Training Hub" />
          <img class="icon active" src="./assets/images/presentation-fill.svg" alt="Training Hub" />
          <span class="label">Training Hub</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <h2 *ngIf="
        ([permissions_entity.modules.cct_interview_master]
          | permissions
          | async) ||
        ([permissions_entity.modules.cct_interview_request]
          | permissions
          | async) ||
        ([permissions_entity.modules.cct_assign_interview]
          | permissions
          | async) ||
        ([permissions_entity.modules.cct_view_interview]
          | permissions
          | async) ||
        ([permissions_entity.modules.cct_quality_master] | permissions | async)
      ">
      Others
    </h2>

    <mat-expansion-panel *ngIf="
        ([permissions_entity.modules.cct_interview_master]
          | permissions
          | async) ||
        ([permissions_entity.modules.cct_interview_request]
          | permissions
          | async) ||
        ([permissions_entity.modules.cct_assign_interview]
          | permissions
          | async) ||
        ([permissions_entity.modules.cct_view_interview]
          | permissions
          | async) ||
        ([permissions_entity.modules.cct_quality_master] | permissions | async)
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/student-interview-icon-gray.svg" alt="Student Interview" />
          <img class="icon active" src="./assets/images/student-interview-icon-orange.svg" alt="Student Interview" />
          <span class="label">Student Interview (CCT)</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.cct_interview_master]
            | permissions
            | async
        ">
        <button mat-button (click)="goToInterviewMaster()">
          Interview Master
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.cct_interview_request]
            | permissions
            | async
        ">
        <button mat-button (click)="goToInterviewRequest()">
          Interview Request
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.cct_assign_interview]
            | permissions
            | async
        ">
        <button mat-button (click)="goToAssignInterview()">
          Assign Interview
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.cct_assign_interview]
            | permissions
            | async
        ">
        <button mat-button (click)="goToAssignBatchInterview()">
          Assign Batch Interview
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.cct_view_interview] | permissions | async
        ">
        <button mat-button (click)="goToViewInterview()">View Interview</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.cct_quality_master] | permissions | async
        ">
        <button mat-button (click)="goToQualityMaster()">Quality Master</button>
      </div>
      <div class="expansion-content">
        <button mat-button (click)="goToEnrolyLogs()">
          Enroly Logs
        </button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.voucher] | permissions | async">
      <mat-expansion-panel-header (click)="goToVoucher()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/voucher-icon-gray.svg" alt="Voucher" />
          <img class="icon active" src="./assets/images/voucher-icon-orange.svg" alt="Voucher" />
          <span class="label">Voucher</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.accommodation] | permissions | async">
      <mat-expansion-panel-header (click)="goToAccommodation()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/voucher-icon-gray.svg" alt="Voucher" />
          <img class="icon active" src="./assets/images/voucher-icon-orange.svg" alt="Voucher" />
          <span class="label">Accommodation Enquiry</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.loan_enquiry] | permissions | async">
      <mat-expansion-panel-header (click)="goToLoanEnquiryList()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/voucher-icon-gray.svg" alt="Voucher" />
          <img class="icon active" src="./assets/images/voucher-icon-orange.svg" alt="Voucher" />
          <span class="label">Loan Enquiry List</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.scholarship_list] | permissions | async
      ">
      <mat-expansion-panel-header (click)="goToScholarshipList()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/voucher-icon-gray.svg" alt="Voucher" />
          <img class="icon active" src="./assets/images/voucher-icon-orange.svg" alt="Voucher" />
          <span class="label">Scholarship Enquiry List</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="[permissions_entity.modules.reports] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/report-icon-gray.svg" alt="Reports" />
          <img class="icon active" src="./assets/images/report-icon-orange.svg" alt="Reports" />
          <span class="label">Reports</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.application_status_tat] | permissions | async
        ">
        <button mat-button (click)="goToVisaRefusals()">
          Visa Refusals
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.user_mail_activity] | permissions | async
        ">
        <button mat-button (click)="goToUserMailActivity()">
          User Mail Activity
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.user_mail_box] | permissions | async
        ">
        <button mat-button (click)="goToUniversityMailboxes()">
          University Mailboxes
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.application_reports] | permissions | async
        ">
        <button mat-button (click)="goToApplicationReports()">
          Applications Reports
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.application_received]
            | permissions
            | async
        ">
        <button mat-button (click)="goToApplicationReceived()">
          Application Received
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.agent_not_given_application_report]
            | permissions
            | async
        ">
        <button mat-button (click)="goToAgentNotGivenApplication()">
          Agent Not Given Application
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.agent_not_given_application_report]
            | permissions
            | async
        ">
        <button mat-button (click)="goToAgentNotPaid()">Agent Not Paid</button>
      </div>
      <div class="expansion-content" 
      *ngIf="
          [permissions_entity.modules.blocked_agents]
            | permissions
            | async
        ">
        <button mat-button (click)="goToBlockedAgents()">Blocked Agents</button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.qc_reports] | permissions | async">
        <button mat-button (click)="goToIndividualQCReports()">
          Individual QC Reports
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.payment_reports] | permissions | async
        ">
        <button mat-button (click)="goToPaymentReports()">
          Payment Reports
        </button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.user_mail] | permissions | async">
        <button mat-button (click)="goToUserMail()">User Mail</button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.list_agent] | permissions | async">
        <button mat-button (click)="goToAgentList()">Agent List</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.assessor_reports] | permissions | async
        ">
        <button mat-button (click)="goToyear()">Year On Year Comparison</button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.dnj_reports] | permissions | async">
        <button mat-button (click)="dnjReports()">DNJ Report</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.application_flow_report]
            | permissions
            | async
        ">
        <button mat-button (click)="applicatonFlowReport()">
          Application Flow Report
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.cas_to_interview_request]
            | permissions
            | async
        ">
        <button mat-button (click)="casInterview()">
          CAS to Interview Request
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.interview_report] | permissions | async
        ">
        <button mat-button (click)="interviewReport()">Interview Report</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.application_flow_report]
            | permissions
            | async
        ">
        <button mat-button (click)="applicatonLifeline()">
          Application lifeline
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.automation_reports] | permissions | async
        ">
        <button mat-button (click)="automationReport()">
          Automation Report
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.cas_to_interview_request]
            | permissions
            | async
        ">
        <button mat-button (click)="cptReport()">CPT Report</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.agent_never_logged] | permissions | async
        ">
        <button mat-button (click)="agentNeverLogged()">
          Agent Never Logged
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.agent_approval_log] | permissions | async
        ">
        <button mat-button (click)="agentApprovalLog()">
          Agent Approval Log
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.case_owner_reports] | permissions | async
        ">
        <button mat-button (click)="caseOwnerReport()">
          Case Owner Report
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.african_reports] | permissions | async
        ">
        <button mat-button (click)="africanReports()">African Reports</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.cas_dynamics_report] | permissions | async
        ">
        <button mat-button (click)="casReports()">Cas Dynamics Report</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.ai_eligibility_check_report]
            | permissions
            | async
        ">
        <button mat-button (click)="aiEligibilityCheckReport()">
          AI Eligibility Check Report
        </button>
      </div>
      <!-- <div class="expansion-content"
                *ngIf="[permissions_entity.modules.interviewer_call_log_report] | permissions | async">
                <button mat-button (click)="interviewerCallLogReport()">Interviewer Call Log Report</button>
            </div> -->
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.received_dynamics_report]
            | permissions
            | async
        ">
        <button mat-button (click)="receivedDynamicReport()">
          Received Dynamics Report
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.rm_call_log_report] | permissions | async
        ">
        <button mat-button (click)="rmCallLogReport()">
          RM Call Log Report
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.rm_call_log_report] | permissions | async
        ">
        <button mat-button (click)="allUserCallLogReport()">
          All Users Call Log
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.application_reports_mm]
            | permissions
            | async
        ">
        <button mat-button (click)="applicationReportsMM()">
          Application Reports MM
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.duplicate_agent_list]
            | permissions
            | async
        ">
        <button mat-button (click)="duplicateAgentReport()">
          Duplicate Agent Report
        </button>
      </div>
      <!-- <div class="expansion-content" *ngIf="[permissions_entity.modules.whatsApp_log] | permissions | async">
                <button mat-button (click)="whatsappReport()">WhatsApp Call Log</button>
            </div> -->
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.offer_timeline_report]
            | permissions
            | async
        ">
        <button mat-button (click)="timelineReport()">
          Offer Timeline Report
        </button>
      </div>

      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.global_tree_counsellor_report]
            | permissions
            | async
        ">
        <button mat-button (click)="globalTreeReport()">Global Tree Counsellors</button>
      </div>  
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.call_recoding_report]
            | permissions
            | async
        ">
        <button mat-button (click)="recodingReport()">Call Recoding Report</button>
      </div>     
    </mat-expansion-panel> 

    <h2 *ngIf="
        ([permissions_entity.modules.admin_notice_board]
          | permissions
          | async) ||
        ([permissions_entity.modules.agent_notice_board]
          | permissions
          | async) ||
        ([permissions_entity.modules.agent_webinar_board] | permissions | async)
      ">
      Notice Board
    </h2>
    <!-- <mat-expansion-panel *ngIf="[permissions_entity.modules.admin_notice_board] | permissions | async">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <img class="icon normal" src="./assets/images/admin-notice-board-icon-gray.svg"
                        alt="Admin Notice Board" />
                    <img class="icon active" src="./assets/images/admin-notice-board-icon-orange.svg"
                        alt="Admin Notice Board" />
                    <span class="label">Admin Notice Board</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="expansion-content"
                *ngIf="[permissions_entity.modules.admin_notice_board] | permissions | async">
                <button mat-button (click)="gotoAdminNotice()">Admin Notice Board</button>
            </div>
        </mat-expansion-panel> -->

    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.admin_notice_board] | permissions | async
      ">
      <mat-expansion-panel-header (click)="gotoAdminNotice()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/admin-notice-board-icon-gray.svg" alt="Admin Notice Board" />
          <img class="icon active" src="./assets/images/admin-notice-board-icon-orange.svg" alt="Admin Notice Board" />
          <span class="label">Admin Notice Board</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="
        ([permissions_entity.modules.agent_notice_board]
          | permissions
          | async) ||
        ([permissions_entity.modules.agent_webinar_board] | permissions | async)
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/agent-notice-board-icon-gray.svg" alt="Agent Notice Board" />
          <img class="icon active" src="./assets/images/agent-notice-board-icon-orange.svg" alt="Agent Notice Board" />
          <span class="label">Agent Notice Board</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button (click)="gotoFrontendNotice()" *ngIf="
            [permissions_entity.modules.agent_notice_board]
              | permissions
              | async
          ">
          Frontend Notice Board
        </button>
        <button mat-button (click)="gotoFrontendWebinar()" *ngIf="
            [permissions_entity.modules.agent_webinar_board]
              | permissions
              | async
          ">
          Frontend Webinar Board
        </button>
      </div>
    </mat-expansion-panel>

    <!-- <h2>Crizac Mail</h2>
        <mat-expansion-panel *ngIf="userAccounts.length > 1">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <img class="icon normal" src="./assets/images/mailbox-icon-gray.svg" alt="Inbox" />
                    <img class="icon active" src="./assets/images/mailbox-icon-orange.svg" alt="Inbox" />
                    <span class="label">All Mails</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="expansion-content mail-btns-group">
                <ng-container *ngFor="let folder of allMailFolders">
                    <button mat-button *ngIf="folder.label !== 'Personal Mail' && folder.label !== 'Shared With Me'"
                        (click)="goToMail(folder.label, folder.type, dashboardData?.domain, dashboardData?.email, userType)">
                        <span class="icon-group">
                            <img class="icon normal" [src]="'./assets/images/' + folder?.image + '-icon-gray.svg'"
                                alt="Inbox" />
                            <img class="icon active" [src]="'./assets/images/' + folder?.image + '-icon-orange.svg'"
                                alt="Inbox" />
                        </span>
                        {{ folder.label }}
                        <span class="counter" *ngIf="folder.countKey && dashboardData?.[folder.countKey]">{{
                            dashboardData[folder.countKey] }}</span>
                    </button>
                </ng-container>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel *ngFor="let account of userAccounts"
            (opened)="onPanelOpened(account?.mail, false, account?.domain, account?.isPersonal)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <img class="icon normal" src="./assets/images/mailbox-icon-gray.svg" alt="Inbox" />
                    <img class="icon active" src="./assets/images/mailbox-icon-orange.svg" alt="Inbox" />
                    <span class="label">{{ account?.mail }}</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="expansion-content mail-btns-group">
                <ng-container *ngFor="let folder of allMailFolders">
                    <button mat-button
                        *ngIf="(userType && account?.isPersonal === 'true') || folder.label !== 'Personal Mail'"
                        (click)="goToMail(folder.label, folder.type, account?.domain, account?.mail, userType, account?.isPersonal)">
                        <span class="icon-group">
                            <img class="icon normal" [src]="'./assets/images/' + folder?.image + '-icon-gray.svg'"
                                alt="Inbox" />
                            <img class="icon active" [src]="'./assets/images/' + folder?.image + '-icon-orange.svg'"
                                alt="Inbox" />
                        </span>
                        {{ folder.label }}
                        <span class="counter"
                            *ngIf="folder.countKey && dashboardDataMap[account?.mail]?.[folder.countKey]">
                            {{ dashboardDataMap[account?.mail][folder.countKey] }}
                        </span>
                    </button>
                </ng-container>
            </div>
        </mat-expansion-panel> -->
    <h2 *ngIf="
        ([permissions_entity.modules.call_logs] | permissions | async) ||
        ([permissions_entity.modules.aiInterview] | permissions | async) ||
        ([permissions_entity.modules.automation_log] | permissions | async) ||
        ([permissions_entity.modules.referred_qc] | permissions | async)
      ">
      Logs
    </h2>
    @if (false) {
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.call_logs] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/call-log-icon-gray.svg" alt="Call Logs" />
          <img class="icon active" src="./assets/images/call-log-icon-orange.svg" alt="Call Logs" />
          <span class="label">Call Logs</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    }
    @if (false) {
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.aiInterview] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/interview-log-icon-gray.svg" alt="AI Interview Logs" />
          <img class="icon active" src="./assets/images/interview-log-icon-orange.svg" alt="AI Interview Logs" />
          <span class="label">AI Interview Logs</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    }
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.mail_automation_logs] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/interview-log-icon-gray.svg" alt="AI Interview Logs" />
          <img class="icon active" src="./assets/images/interview-log-icon-orange.svg" alt="AI Interview Logs" />
          <span class="label" (click)="gotoMailAutomationLogs()">Mail Automation Log</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.automation_log] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/automation-logs-icon-gray.svg" alt="Automation Logs" />
          <img class="icon active" src="./assets/images/automation-logs-icon-orange.svg" alt="Automation Logs" />
          <span class="label" (click)="gotoAutomationLogs()">Automation Logs</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.automation_activity_log]
          | permissions
          | async
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/activity-logs-icon-gray.svg" alt="Activity Logs" />
          <img class="icon active" src="./assets/images/activity-logs-icon-orange.svg" alt="Activity Logs" />
          <span class="label" (click)="gotoActivityLogs()">Activity Logs</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="
        ([permissions_entity.modules.ai_automation_logs]
          | permissions
          | async) ||
        ([permissions_entity.modules.ai_university_list] | permissions | async)
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/activity-logs-icon-gray.svg"
            alt="Create Dynamic Automation Form" />
          <img class="icon active" src="./assets/images/activity-logs-icon-orange.svg" alt="AI Automation Logs" />
          <span class="label">AI Automation</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button (click)="onAiAutomationLogs()" *ngIf="
            [permissions_entity.modules.ai_automation_logs]
              | permissions
              | async
          ">
          AI Automation Logs
        </button>
        <button mat-button (click)="onAiUniversityList()" *ngIf="
            [permissions_entity.modules.ai_university_list]
              | permissions
              | async
          ">
          AI University List
        </button>

        <button mat-button (click)="onAiUniversityLogs()" *ngIf="
            [permissions_entity.modules.ai_university_logs]
              | permissions
              | async
          ">
          AI University Logs
        </button>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.referred_qc] | permissions | async">
      <mat-expansion-panel-header (click)="goToReferredQC()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/reffered-icon-gray.svg" alt="Referred QC" />
          <img class="icon active" src="./assets/images/reffered-icon-orange.svg" alt="Referred QC" />
          <span class="label">Referred QC</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.ai_automation_logs] | permissions | async">
      <mat-expansion-panel-header (click)="onAiOfferLog()">
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/automation-logs-icon-gray.svg" alt="AI Offer Logs" />
          <img class="icon active" src="./assets/images/automation-logs-icon-orange.svg" alt="AI Offer Logs" />
          <span class="label">AI Offer Logs</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <h2 *ngIf="
        ([permissions_entity.modules.agent_reminder] | permissions | async) ||
        ([permissions_entity.modules.mail_rule_form] | permissions | async)
      ">
      Mail Logs
    </h2>
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.agent_reminder] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/automation-mail-icon.svg" alt="Automation Logs"
            style="width: 18px; height: 18px; object-fit: contain" />
          <img class="icon active" src="./assets/images/automation-mail-icon-orang.svg" alt="Automation Logs"
            style="width: 18px; height: 18px; object-fit: contain" />
          <span class="label" (click)="gotoAutomationmailLogs()">Agent Reminder</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.mail_rule_form] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/form-svg-gray.svg" alt="Automation Mail Logs"
            style="width: 18px; height: 18px; object-fit: contain" />
          <img class="icon active" src="./assets/images/form-svg-orange.svg" alt="Automation Mail Logs"
            style="width: 18px; height: 18px; object-fit: contain" />
          <span class="label" (click)="gotoAutomationmailFormLogs()">Mail Rule Master</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.mail_assigner_rules] | permissions | async">
      <mat-expansion-panel-header (click)="goToNewList()">
        <mat-panel-title>
          <img class="icon normal" style="width: 18px; height: 18px; object-fit: contain" src="./assets/images/form-svg-gray.svg" alt="Mail Assigner Rules" />
          <img class="icon active" style="width: 18px; height: 18px; object-fit: contain" src="./assets/images/form-svg-orange.svg" alt="Mail Assigner Rules" />
          <span class="label">Mail Assigner Rules</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <h2 *ngIf="[permissions_entity.modules.setting] | permissions | async">
      Settings
    </h2>

    <mat-expansion-panel *ngIf="
        ([permissions_entity.modules.application_primary_status]
          | permissions
          | async) ||
        ([permissions_entity.modules.application_secondary_status]
          | permissions
          | async) ||
        ([permissions_entity.modules.application_internal_status]
          | permissions
          | async) ||
        ([permissions_entity.modules.application_communication_status]
          | permissions
          | async)
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/university-master-icon-gray.svg" alt="Application Status" />
          <img class="icon active" src="./assets/images/university-master-icon-orange.svg" alt="Application Status" />
          <span class="label">Application Status</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button (click)="goToPrimary()" *ngIf="
            [permissions_entity.modules.application_primary_status]
              | permissions
              | async
          ">
          Primary Status
        </button>
        <!-- <button mat-button (click)="goToAuto()">Auto Changes</button> -->
        <button mat-button (click)="goToSecondary()" *ngIf="
            [permissions_entity.modules.application_secondary_status]
              | permissions
              | async
          ">
          Secondary Status
        </button>
        <button mat-button (click)="goToInternal()" *ngIf="
            [permissions_entity.modules.application_internal_status]
              | permissions
              | async
          ">
          Internal Status
        </button>
        <button mat-button (click)="goToCommunication()" *ngIf="
            [permissions_entity.modules.application_communication_status]
              | permissions
              | async
          ">
          Communication Status
        </button>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="[permissions_entity.modules.university] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/university-master-icon-gray.svg" alt="University Master" />
          <img class="icon active" src="./assets/images/university-master-icon-orange.svg" alt="University Master" />
          <span class="label">University Master</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button (click)="goToUniversity()"
          *ngIf="[permissions_entity.modules.university] | permissions | async">
          University
        </button>
        <button mat-button (click)="goToUniversityAffiliate()" *ngIf="
            [permissions_entity.modules.university_affiliate]
              | permissions
              | async
          ">
          University Affiliate
        </button>
        <button mat-button (click)="goToUniversityProcessLink()" *ngIf="
            [permissions_entity.modules.universities_process_link]
              | permissions
              | async
          ">
          University Process Link
        </button>
        <button mat-button (click)="goToUniversityFilterMaster()" *ngIf="
            [permissions_entity.modules.universities_filter_master]
              | permissions
              | async
          ">
          University Filter Master
        </button>
        <button mat-button (click)="goToUniversityFilterPG()" *ngIf="
            [permissions_entity.modules.university_filter_pg]
              | permissions
              | async
          ">
          University Filter PG
        </button>
        <button mat-button (click)="goToUniversityFilterUG()" *ngIf="
            [permissions_entity.modules.university_filter_ug]
              | permissions
              | async
          ">
          University Filter UG
        </button>
        <button mat-button (click)="goToUniversityCoCptArt()" *ngIf="
            [permissions_entity.modules.university_cat_cpt_art]
              | permissions
              | async
          ">
          University CO/CPT/ART
        </button>
      </div>
    </mat-expansion-panel>

    <!-- Search Program, in the slot the two Master entries used to fill. The
         same page as the B2C Module entry above (one route, one component);
         it is listed here too so the people who reached the catalogue through
         this section still have a way in. Gated on the SAME permissions the
         entries it replaced used, so exactly that audience keeps seeing it. -->
    <mat-expansion-panel hideToggle *ngIf="
        [
          permissions_entity.modules.university,
          permissions_entity.modules.courses
        ] | permissions | async
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <a class="nav-link" (click)="searchProgram()">
            <img class="icon normal" src="./assets/images/course-master-icon-gray.svg" alt="Search Program" />
            <img class="icon active" src="./assets/images/course-master-icon-orange.svg" alt="Search Program" />
            <span class="label">Search Program</span>
          </a>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
    <!-- REWIRED TKT-4502.1 — the flat "University Master" / "Course Master"
         shortcuts that replaced these on 2026-09-21 are removed; the full
         expandable menus above and below are restored to match the old
         console. "Search Program" above is unaffected. -->

    <mat-expansion-panel *ngIf="[permissions_entity.modules.courses] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/course-master-icon-gray.svg" alt="Course Master" />
          <img class="icon active" src="./assets/images/course-master-icon-orange.svg" alt="Course Master" />
          <span class="label">Course Master</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.courses] | permissions | async">
        <button mat-button (click)="goToCourseMasterCourses()">Courses</button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.options] | permissions | async">
        <button mat-button (click)="goToCourseMasterOptions()">Options</button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.filters] | permissions | async">
        <button mat-button (click)="goToCourseMasterFilters()">Filters</button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="[permissions_entity.modules.admin_master] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/admin-master-icon-gray.svg" alt="Admin Master" />
          <img class="icon active" src="./assets/images/admin-master-icon-orange.svg" alt="Admin Master" />
          <span class="label">Admin Master</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.loan] | permissions | async">
        <button mat-button (click)="goToLoanList()">Loan Entry</button>
      </div>
      <!-- <div class="expansion-content" *ngIf="[permissions_entity.modules.loan] | permissions | async">
                <button mat-button (click)="goToLoanEnquiryList()">Loan Enquiry List</button>
            </div> -->
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.universitydeadline] | permissions | async
        ">
        <button mat-button (click)="goToApplicationDeadline()">
          Application Deadline
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.offer_timeline] | permissions | async
        ">
        <button mat-button (click)="goToOfferTimeline()">
          Offer Timeline
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.accomodation_commission]
            | permissions
            | async
        ">
        <button mat-button (click)="goToAccommodationCommission()">
          Accommodation Commission
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.accomodation_vendor]
            | permissions
            | async
        ">
        <button mat-button (click)="goToAccommodationVendor()">
          Accommodation Vendor
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.interview_type] | permissions | async
        ">
        <button mat-button (click)="goToInterViewType()">InterView Type</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.interview_mode] | permissions | async
        ">
        <button mat-button (click)="goToInterViewMode()">InterView Mode</button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.religions] | permissions | async">
        <button mat-button (click)="goToInternalOtions()">
          Internal Options
        </button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.training_hub] | permissions | async">
        <button mat-button (click)="goToTrainingHub()">Training Hub</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.document_restrictions]
            | permissions
            | async
        ">
        <button mat-button (click)="goToDocumentRestriction()">
          Document Restriction
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.employee_designation]
            | permissions
            | async
        ">
        <button mat-button (click)="goToEmployeeDesignation()">
          Employee Designation
        </button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.job_role] | permissions | async">
        <button mat-button (click)="goToJobRole()">Job Role</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.password_manager] | permissions | async
        ">
        <button mat-button (click)="goToPasswordManager()">
          Password Manager
        </button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.ofiice_layout] | permissions | async">
        <button mat-button (click)="goToOfficeLayout()">Office Layout</button>
      </div>
      <div class="expansion-content">
        <button mat-button (click)="goToConferenceRooms()">Conference Rooms</button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.mail_sender] | permissions | async">
        <button mat-button (click)="goToMailSender()">Mail Senders</button>
      </div>
      <div class="expansion-content" *ngIf="[permissions_entity.modules.user_groups] | permissions | async">
        <button mat-button (click)="goToUserGroups()">Users Groups</button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.university_contract] | permissions | async
        ">
        <button mat-button (click)="goToUniversityContract()">
          University Contract
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.store_commissions] | permissions | async
        ">
        <button mat-button (click)="goToStoreCommissions()">
          Store Commissions
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.whatsapp_numbers] | permissions | async
        ">
        <button mat-button (click)="goToWhatsappNumbers()">
          Whatsapp Numbers
        </button>
      </div>
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.whatsapp_group] | permissions | async
        ">
      <!-- <div class="expansion-content"> -->
        <button mat-button (click)="goToWhatsappGroupsList()">
          Whatsapp Groups
        </button>
      </div>
      <!-- <div class="expansion-content" 
       *ngIf="[permissions_entity.modules.secondary_status_assignment] | permissions | async ">
      
        <button mat-button (click)="goToSecondaryStatusAssignment()">
          Secondary Status Assignment
        </button>
      </div> -->
      <div class="expansion-content" *ngIf="
          [permissions_entity.modules.application_assignment] | permissions | async
        ">
        <button mat-button class="secondary-status-btn" (click)="goToApplicationAssignment()">
          Application Assignment
        </button>
      </div>
      <!-- <div class="expansion-content"
                <button mat-button (click)="goToLeadSource()">Lead Source</button>
            </div> -->
    </mat-expansion-panel>
    @if (false) {
    <mat-expansion-panel *ngIf="
          [permissions_entity.modules.qualifications_master]
            | permissions
            | async
        ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/qualifications-gray-icon.svg" alt="Qualifications Master" />
          <img class="icon active" src="./assets/images/qualifications-orange-icon.svg" alt="Qualifications Master" />
          <span class="label">Qualifications Master</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button>Qualifications Master</button>
      </div>
    </mat-expansion-panel>
    }
    <mat-expansion-panel *ngIf="[permissions_entity.modules.email_master] | permissions | async">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/activity-logs-icon-gray.svg" alt="Email Master" />
          <img class="icon active" src="./assets/images/activity-logs-icon-orange.svg" alt="Email   Master" />
          <span class="label">Email Master</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button *ngIf="[permissions_entity.modules.smtp] | permissions | async" (click)="goToSmtp()">
          SMTP
        </button>
      </div>
      <div class="expansion-content">
        <button mat-button *ngIf="
            [permissions_entity.modules.email_template] | permissions | async
          " (click)="goToEmailTemplate()">
          Email Template
        </button>
      </div>
      <div class="expansion-content">
        <button mat-button *ngIf="
            [permissions_entity.modules.universities_email]
              | permissions
              | async
          " (click)="goToUniversityEmail()">
          University E-mail Id
        </button>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.automation_master] | permissions | async
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/automation-master-gray-icon.svg" alt="Automation Master" />
          <img class="icon active" src="./assets/images/automation-master-orange-icon.svg" alt="Automation Master" />
          <span class="label">Automation Master</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="
        ([permissions_entity.modules.lead_source] | permissions | async) ||
        ([permissions_entity.modules.lead_primary_status]
          | permissions
          | async) ||
        ([permissions_entity.modules.lead_secondary_status]
          | permissions
          | async) ||
        ([permissions_entity.modules.lead_internal_status]
          | permissions
          | async) ||
        ([permissions_entity.modules.lead_communication_status]
          | permissions
          | async)
      ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/university-master-icon-gray.svg" alt="Application Status" />
          <img class="icon active" src="./assets/images/university-master-icon-orange.svg" alt="Application Status" />
          <span class="label">Lead Master</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="expansion-content">
        <button mat-button (click)="goToLeadSource()"
          *ngIf="[permissions_entity.modules.lead_source] | permissions | async">
          Lead Source
        </button>
        <button mat-button (click)="goToLeadStatus('primary')" *ngIf="
            [permissions_entity.modules.lead_primary_status]
              | permissions
              | async
          ">
          Primary Status
        </button>
        <!-- <button mat-button (click)="goToAuto()">Auto Changes</button> -->
        <button mat-button (click)="goToLeadStatus('secondary')" *ngIf="
            [permissions_entity.modules.lead_secondary_status]
              | permissions
              | async
          ">
          Secondary Status
        </button>
        <button mat-button (click)="goToLeadFollowupStaus()"
          *ngIf="[permissions_entity.modules.lead_followup_status] | permissions | async">
          Follow Up Status
        </button>
        <!-- <button mat-button (click)="goToLeadStatus('internal')"
                    *ngIf="[permissions_entity.modules.lead_internal_status] | permissions | async">Internal
                    Status</button>
                <button mat-button (click)="goToLeadStatus('communication')"
                    *ngIf="[permissions_entity.modules.lead_communication_status] | permissions | async">Communication
                    Status</button> -->
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.branch_office] | permissions | async"
      (click)="goToBranchOffice()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/automation-master-gray-icon.svg" alt="Branch Office" />
          <img class="icon active" src="./assets/images/automation-master-orange-icon.svg" alt="Branch Office" />
          <span class="label">Branch Office</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <mat-expansion-panel hideToggle *ngIf="[permissions_entity.modules.english_test_voucher] | permissions | async"
      (click)="goToEnglishVoucher()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/english.svg" alt="Branch Office" />
          <img class="icon active" src="./assets/images/english.svg" alt="Branch Office" />
          <span class="label">English Test Voucher</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <h2 *ngIf="
        [permissions_entity.modules.create_dynamic_form] | permissions | async
      ">
      Dynamic Form
    </h2>
    <mat-expansion-panel hideToggle *ngIf="
        [permissions_entity.modules.create_dynamic_form] | permissions | async
      " (click)="onDynamicClick()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <img class="icon normal" src="./assets/images/dynamic-form.svg" alt="Create Dynamic Automation Form" />
          <img class="icon active" src="./assets/images/dynamic-form-orange.svg" alt="Create Dynamic Automation Form" />
          <span class="label">Create Dynamic Form</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </mat-accordion>

  <app-footer></app-footer>
</aside>
